import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentsService {

  constructor(private http:HttpClient) { }

  public uploadDocument(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
  }

  public deleteDocument(payload): Observable<any>{
    return this.http.post(environment.BASE_URL_COMMON+'attachment/deleteByDocumentId',payload)
  }

  public getAttachmentByDocumentId(payload){
    return this.http.post(environment.BASE_URL_COMMON+'attachment/getAttachmentByDocumentId',payload)
  }

  //  public uploadDocument(payload): Observable<any>{
  //   return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
  // }
}
